import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentRepository {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient
  ) { }

  public sendPayment(params: any, queryString?: string): Observable<any> {
    let api = '';

    if (queryString) {
      api = `${this.apiUrl}/order?${queryString}`;
    } else {
      api = `${this.apiUrl}/order`;
    }
    return this.httpClient.post<any>(api, params);
  }

}
